import React, { useState, useEffect } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import { SearchOutlined } from "@ant-design/icons";
function User_permission(props) {
  const [loading, sendRequest] = useAxios();
  const [isErrOpen, setisErrOpen] = useState(false);
  const [api_error_message, setapi_error_message] = useState();
  const [searchid, setSearchId] = useState();
  const [mapping_data, setmapping_data] = useState();
  const [user_mapping_data, setuser_mapping_data] = useState();
  const [effetive_designation_id, seteffetive_designation_id] = useState();
  const [effetive_designation_idList, seteffetive_designation_idList] = useState();
  const [branch_list, setbranch_list] = useState();
  const [selectedUser, setSelectedUser] = useState(null);
  const [clickedUser, setClickedUser] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isUsernameClicked, setIsUsernameClicked] = useState([]);
  const [userMappingDataList, setUserMappingDataList] = useState({});
  const [branch_id, setbranch_id] = useState();
  const [branchIds, setBranchIds] = useState({});
  const [designationIds, setDesignationIds] = useState({});
  const [response_message, setresponse_message] = useState();
  const [errorModal, setErrorModal] = useState(false);
  const [resetDropdowns, setResetDropdowns] = useState(false);
  const [branchError, setBranchError] = useState({});
  const [designationError, setDesignationError] = useState({});
  
  const resetDropdownsHandler = () => {
    console.log("Resetting dropdowns...");
    setResetDropdowns(false);
  
    
    setBranchIds({});
    setDesignationIds({});
  };
  useEffect(() => {
    let apitoken = localStorage.getItem("api_token");
    if (!effetive_designation_idList) {
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/get/designation/list`,
          method: "GET",
          headers: {
            "api-token": apitoken,
          },
        },
        (response) => {
          console.log("Designation Data Response:", response);
          seteffetive_designation_idList(response);
        },
        (error) => {
          console.error("Error fetching designation list:", error);
        }
      );
    }
    if (!branch_list) {
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/get/branch/list`,
          method: "GET",
          headers: {
             "api-token": apitoken, 
          },
        },
        (response) => {
          console.log("Branch Data Response:", response);
          setbranch_list(response);
        },
        (error) => {
          console.error("Error in API request", error);
          setapi_error_message("Error in API request");
          setisErrOpen(true);
        }
      );
    }
  }, []);
  const search_input = () => {
    let apitoken = localStorage.getItem("api_token");
    const queryParams = {
      searchid: searchid,
    };
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/get/user_details`,
        method: "GET",
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("Search result", response);
        setmapping_data(response);
      },
      (error) => {
        console.error("Error in API request", error);
        setapi_error_message("Error in API request");
        setisErrOpen(true);
      }
    );
  };
  
  const submit_data = (user) => {
    let apitoken = localStorage.getItem("api_token");
    const userBranchId = branchIds[user.user_id];
    const userDesignationId = designationIds[user.user_id];
    setClickedUser(user);
  
    
    if (!userBranchId) {
      setBranchError({ [user.user_id]: "Please select a branch" });
      return;
    } else {
      setBranchError({ [user.user_id]: "" });
    }
  
    if (!userDesignationId) {
      setDesignationError({ [user.user_id]: "Please select a designation" });
      return;
    } else {
      setDesignationError({ [user.user_id]: "" });
    }
  
    const form = new FormData();
    form.append('userid', user.user_id);
    form.append("branch_id", userBranchId);
    form.append("mapped_designation_id", userDesignationId);
  
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/save/user/permission_data`,
        method: "POST",
        data: form,
        headers: {
          "Content-Type": "multipart/form-data",
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log(response);
        setresponse_message(response.message);
        setErrorModal(true);
        setResetDropdowns(true);
      },
      (error) => {
        console.error("Error in API request", error);
        setresponse_message("Error in API request");
        setErrorModal(true);
        setResetDropdowns(true);
        
      }
    );
  };
  
  
  const openModal = (user) => {
    setShowModal(false);
    
    setSelectedUser(user);
    setShowModal(true);
  
    setIsUsernameClicked((prevIsUsernameClicked) => {
      const newIsUsernameClicked = { ...prevIsUsernameClicked };
      
      
      Object.keys(newIsUsernameClicked).forEach((userId) => {
        newIsUsernameClicked[userId] = false;
      });
  
      
      newIsUsernameClicked[user.user_id] = true;
  
      return newIsUsernameClicked;
    });
  
    let apitoken = localStorage.getItem("api_token");
  
    const queryParams = {
      userid: user.user_id,
    };
  
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/user/mapped/details`,
        method: "GET",
        params: queryParams,
        headers: {
          "Content-Type": "application/json",
          "api-token": apitoken,
        },
      },
      (response) => {
        console.log("User Mapped result", response);
  
       
        setUserMappingDataList((prevData) => ({
          ...prevData,
          [user.user_id]: response,
        }));
      },
      (error) => {
        console.error("Error in API request", error);
        setapi_error_message("Error in API request");
        setisErrOpen(true);
       
      }
    );
  };
  
  return (
    <div className="container">
      <Commonheader pagetitle={"User Permission"} props={props} />
      {loading && (
        <div className="load-4">
          <div className="ring-1"></div>
        </div>
      )}
      <div
        className={
          isErrOpen
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisErrOpen(false);
                search_input();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="popuperrtext">{api_error_message}</p>
          </div>
        </div>
      </div>
      
    <div className={errorModal ? "modal d-block mymodal" : "modal fade bd-example-modal-sm"}>
  <div className="modal-dialog modal-lg">
    <div className="modal-content cdb-confirm-box col-sm-12">
      <button
        type="button"
        className="close text-right"
        data-dismiss="modal"
        aria-label="Close"
        onClick={() => {
          setErrorModal(false);
          resetDropdownsHandler();
          openModal(selectedUser);
        }}
        
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <p className="popuperrtext">{response_message}</p>
    </div>
  </div>
</div>
      <div className="mt-4">
        <div className="row">
          <div className="col-md-7 ">
            <input
              name="search_cache"
              className="form-control"
              placeholder="Search User"
              value={searchid}
              onChange={(e) => setSearchId(e.target.value)}
            />
          </div>
          <div className="form-group col-md-2">
            <button className="btn btn-primary" onClick={search_input}>
              <SearchOutlined />
            </button>
          </div>
        </div>
		{mapping_data && mapping_data.length > 0 && (
        <div className="mt-4">
        <table className="table">
          <thead>
            <tr>
              <th>User Name</th>
              <th>Branch</th>
              <th>Designation</th>
              <th> </th>
            </tr>
          </thead>
          <tbody>
            {mapping_data &&
              mapping_data.map((mapdata) => (
                <tr key={mapdata.username}>
                  <td>
                    <button
                      className="btn btn-link"
                      onClick={() => openModal(mapdata)}
                    >
                      {mapdata.username}
                    </button>
                    {isUsernameClicked[mapdata.user_id] && (
          <div>
          <div style={{ display: 'inline-block', verticalAlign: 'top', marginRight: '100px' }}>
          <p style={{ fontWeight: 'bold' }}>Mapped Branches</p>
            {userMappingDataList[mapdata.user_id] &&
              userMappingDataList[mapdata.user_id].data1 &&
              userMappingDataList[mapdata.user_id].data1.map((branch) => (
                <p key={branch.branch_id}>{branch.branch_name}</p>
              ))}
          </div>
          <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
          <p style={{ fontWeight: 'bold' }}>Designation</p>
            {userMappingDataList[mapdata.user_id] &&
              userMappingDataList[mapdata.user_id].data1 &&
              userMappingDataList[mapdata.user_id].data1.map((branch) => (
                <p key={branch.branch_id}>{branch.designation_name}</p>
              ))}
          </div>
        </div>
        )}
                  </td>
                  <td>
                  <select
                    className="form-control custom-dropdown"
                    name="branch_id"
                    value={branchIds[mapdata.user_id] || ""}
                    onChange={(e) => {
                      setBranchIds({
                        ...branchIds,
                        [mapdata.user_id]: e.target.value,
                      });
                      setBranchError({ ...branchError, [mapdata.user_id]: "" });
                    }}
                    disabled={!isUsernameClicked[mapdata.user_id]}
                  >
                    <option value="">Select Branch</option>
                    {branch_list &&
                      branch_list.map((bid) => (
                        <option key={bid.branch_id} value={bid.branch_id}>
                          {bid.branch_name}
                        </option>
                      ))}
                  </select>
                  {branchError[mapdata.user_id] && (
                    <p className="error-message">{branchError[mapdata.user_id]}</p>
                  )}
                </td>
                <td>
                  <select
                    className="form-control"
                    name="effetive_designation_id"
                    value={designationIds[mapdata.user_id] || ""}
                    onChange={(e) => {
                      setDesignationIds({
                        ...designationIds,
                        [mapdata.user_id]: e.target.value,
                      });
                      setDesignationError({ ...designationError, [mapdata.user_id]: "" });
                    }}
                    disabled={!isUsernameClicked[mapdata.user_id]}
                  >
                    <option value="">Select Designation</option>
                    {effetive_designation_idList &&
                      effetive_designation_idList.map((eid) => (
                        <option
                          key={eid.effective_designation_id}
                          value={eid.effective_designation_id}
                        >
                          {eid.designation_name}
                        </option>
                      ))}
                  </select>
                  {designationError[mapdata.user_id] && (
                    <p className="error-message">{designationError[mapdata.user_id]}</p>
                  )}
                </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      onClick={() => submit_data(mapdata)}
                      disabled={!isUsernameClicked[mapdata.user_id]}
                    >
                      Submit
                    </button>
                   
                  </td>
                </tr>
              ))}
          </tbody>
        </table>     
         </div>
		  )}
      </div>
    </div>
    
  );
}
export default User_permission;
